import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Dialog } from "@headlessui/react";
import Close from "@engineering/icons/close";
import { Backdrop, Wrapper, Content, TitleWrapper, Title, ScrollableContent, StyledIconButton, Footer } from "./Overlay.styles";
var defaultProps = {
    width: "normal"
};
var Overlay = function(param) {
    var title = param.title, footerContent = param.footerContent, children = param.children, open = param.open, width = param.width, onClose = param.onClose;
    return /*#__PURE__*/ _jsxs(Dialog, {
        onClose: onClose,
        open: open,
        children: [
            /*#__PURE__*/ _jsx(Backdrop, {}),
            /*#__PURE__*/ _jsx(Wrapper, {
                $width: width,
                children: /*#__PURE__*/ _jsx(Dialog.Panel, {
                    children: /*#__PURE__*/ _jsxs(Content, {
                        children: [
                            /*#__PURE__*/ _jsxs(TitleWrapper, {
                                hasTitle: !!title,
                                children: [
                                    title && /*#__PURE__*/ _jsx(Dialog.Title, {
                                        as: "div",
                                        children: /*#__PURE__*/ _jsx(Title, {
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(StyledIconButton, {
                                        icon: Close,
                                        title: "close" // @TODO: Add translation
                                        ,
                                        onClick: onClose
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(ScrollableContent, {
                                children: children
                            }),
                            footerContent && /*#__PURE__*/ _jsx(Footer, {
                                children: footerContent
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Overlay.defaultProps = defaultProps;
export { Overlay };
